import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "group_by",
  "use": "group_by-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"group_by\"><path d=\"M3.5 12H2v4h4v-1.5H3.5zM6 12h2v-2H6zM3.5 3.5H6V2H2v4h1.5zM12 6h-2v2h2zm2.5 8.5H12V16h4v-4h-1.5zM12 2v1.5h2.5V6H16V2zm0 8h-2v2h2zM6 8h2V6H6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol